<template>
  <div class="damage-block">
    <div class="damage-block__change-block">
      <p-button
        icon="fa fa-sync-alt"
        label="поменять местами причины и признаки"
        @click="reasonFirstMode = !reasonFirstMode"
        class="p-button-sm"
      />
    </div>

    <div class="damage-block__lists">
      <template v-if="reasonFirstMode">
        <div class="damage-block__reason-block">
          <div class="damage-block__reason-list-title">Причины</div>
          <div :style="{ margin: '0 25px', 'margin-bottom': '10px' }">
            <input v-model="reasonSearchValue" placeholder="Поиск..." />
          </div>
          <div class="damage-block__reason-list-container">
            <ReasonList
              :selectedReason="selectedReasonT"
              :searchValue="reasonSearchValue"
              @select-reason="onSelectReason"
            />
          </div>
        </div>
        <div class="damage-block__symptom-block">
          <div class="damage-block__symptom-list-title">Признаки</div>
          <div :style="{ margin: '0 25px', 'margin-bottom': '10px' }">
            <input v-model="symptomSearchValue" placeholder="Поиск..." />
          </div>
          <div class="damage-block__symptom-list-container">
            <SymptomList
              :selectedSymptoms="selectedSymptomsT"
              :searchValue="symptomSearchValue"
              @select-symptom="onSelectSymptom"
            />
          </div>
        </div>
      </template>

      <template v-else>
        <div class="damage-block__symptom-block">
          <div class="damage-block__symptom-list-title">Признаки</div>
          <div :style="{ margin: '0 25px', 'margin-bottom': '10px' }">
            <input v-model="symptomSearchValue" placeholder="Поиск..." />
          </div>
          <div class="damage-block__symptom-list-container">
            <SymptomList
              :selectedSymptoms="selectedSymptomsT"
              :searchValue="symptomSearchValue"
              @select-symptom="onSelectSymptom"
            />
          </div>
        </div>
        <div class="damage-block__reason-block">
          <div class="damage-block__reason-list-title">Причины</div>
          <div :style="{ margin: '0 25px', 'margin-bottom': '10px' }">
            <input v-model="reasonSearchValue" placeholder="Поиск..." />
          </div>
          <div class="damage-block__reason-list-container">
            <ReasonList
              :selectedReason="selectedReasonT"
              :searchValue="reasonSearchValue"
              @select-reason="onSelectReason"
            />
          </div>
        </div>
      </template>
    </div>

    <div class="damage-block__add-block">
      <AddBlock
        :reasonFirstMode="reasonFirstMode"
        :selectedReason="selectedReasonT"
        :selectedSymptoms="selectedSymptomsT"
        @add-damage="onAddDamage"
      />
    </div>

    <div class="damage-block__damages-review">
      <DamagesReview
        :addingTree="addingTree"
        :groupedDamageList="groupedDamageList"
        @remove-damage="onRemoveDamage"
      />
    </div>
  </div>
</template>

<script>
import ReasonList from "./ReasonList";
import SymptomList from "./SymptomList";
import AddBlock from "./AddBlock";
import DamagesReview from "./DamagesReview";

export default {
  name: "TreesDamageBlock",

  components: {
    ReasonList,
    SymptomList,
    AddBlock,
    DamagesReview,
  },

  props: {
    addingTree: Object,
    groupedDamageList: Object,
  },

  data: () => ({
    reasonFirstMode: true,

    selectedReason: null,
    selectedSymptoms2: [],

    selectedReasonT: null,
    selectedSymptomsT: [],

    selectedDamage: null,

    reasonSearchValue: "",
    symptomSearchValue: "",
  }),

  computed: {

    symptomIdListStr() {
      return this.selectedSymptomsT.map((symptom) => symptom.id).join(",");
    },
  },

  watch: {
    reasonFirstMode() {
      this.selectedReasonT = null;
      this.selectedSymptomsT = [];

      this.$store.commit("recount/clearDamageReasonList");
      this.$store.commit("recount/clearDamageSymptomList");

      if (this.reasonFirstMode) {
        this.fetchReasonList();
      } else {
        this.fetchSymptomList();
      }
    },

    selectedReasonT() {
      if (this.reasonFirstMode) {
        this.selectedSymptomsT = [];
      }
    },
  },

  methods: {
    onAddDamage() {
      const damage = {
        reason: this.selectedReasonT,
        symptoms: this.selectedSymptomsT,
      };

      this.$emit("add-damage", damage);

      // console.log('add damage');

      // console.log('reason: ', this.selectedReasonT);
      // console.log('symptoms: ', this.selectedSymptomsT);
    },

    onRemoveDamage(reason_id) {
      this.$emit("remove-damage", reason_id);
    },

    onSelectReason(reason) {
      this.selectedReasonT = reason;
      this.fetchSymptomList();
    },

    onSelectSymptom(selectedSymptom) {
      const findedIndex = this.selectedSymptomsT.findIndex((symptom) => {
        return symptom.id === selectedSymptom.id;
      });
      let flag = (() => {
        let invalid_ids = selectedSymptom.invalid_ids ? selectedSymptom.invalid_ids.match(/[\w.-]+/g).map(Number): [];
        let selected_ids = this.selectedSymptomsT.map(e => Number(e.id));
          let flag = true;
          selected_ids.forEach((e) => {
            if(invalid_ids.includes(e)) {
              flag = false;
            }
          });
          return flag;
        })();
      if (findedIndex === -1) {
        if (flag) {   
          this.selectedSymptomsT.push(selectedSymptom);
        } else {
          this.$toast.add({
            severity: "warn",
            detail: "Конфликт признаков",
            life: 10000,
          });
        }
      } else {
        this.selectedSymptomsT.splice(findedIndex, 1);
      }
      
      if (!this.reasonFirstMode) {
        if (!this.selectedSymptomsT.length) {
          this.selectedReasonT = null;
        }

        this.fetchReasonList();
        this.fetchSymptomList();
      }
    },

    fetchReasonList() {
      const payload = {
        addingTree: this.addingTree,
        reasonFirstMode: this.reasonFirstMode,
        symptomIdListStr: this.symptomIdListStr,
      };

      this.$store.dispatch("recount/fetchDamageReasonList", payload);
    },

    fetchSymptomList() {
      const payload = {
        reasonFirstMode: this.reasonFirstMode,
        addingTree: this.addingTree,
        selectedReason: this.selectedReasonT,
        symptomIdListStr: this.symptomIdListStr,
      };
      this.$store.dispatch("recount/fetchDamageSymptomList", payload);
    },
  },

  created() {
    if (this.reasonFirstMode) {
      this.fetchReasonList();
    } else {
      this.fetchSymptomList();
    }
  },
};
</script>

<style scoped>
.damage-block__change-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.damage-block__lists {
  display: flex;
}

.damage-block__reason-list-title,
.damage-block__symptom-list-title {
  text-align: center;
  margin-bottom: 1rem;
  font-weight: bold;
}

/* .damage-block__reason-block, */
/* .damage-block__symptom-block */
.damage-block__reason-list-container,
.damage-block__symptom-list-container {
  cursor: pointer;
  height: 300px;
  overflow: auto;
  width: 300px;
}

.damage-block__reason-row--selected {
  background-color: lightblue;
}

.damage-block__change-block,
.damage-block__lists,
.damage-block__add-block {
  margin-bottom: 1.5rem;
}
</style>
